import { useEffect } from 'react'

import { useParams, useSearch } from '@tanstack/react-router'

import { useSettingsAndTranslations } from '@/hooks/use-settings-and-translations'

export function useLocalizeDocumentAttributes() {
  const { dexfSettings } = useSettingsAndTranslations()
  const { language } = useParams({ strict: false })
  const { ipexGallery: isLanda, origin } = useSearch({ strict: false })

  useEffect(() => {
    if (!language) return
    document.documentElement.lang = language
    document.documentElement.dir = dexfSettings.localisation.writeDirection

    // if kiosk
    if (isLanda || origin) {
      document.documentElement.style.fontSize = '18px'
    }

    // if upptacka
    if (origin) {
      document.documentElement.setAttribute('data-upptacka', '')
    }

    return () => {
      document.documentElement.lang = 'en'
      document.documentElement.dir = 'ltr'
      document.documentElement.style.fontSize = '100%'
      document.documentElement.removeAttribute('data-upptacka')
    }
  }, [language, dexfSettings.localisation.writeDirection, isLanda, origin])
}
